export const LOGIN = 'auth/LOGIN'
export const LOGOUT = 'auth/LOGOUT'
export const SET_USER_ENTITY = 'auth/SET_USER_ENTITY'